import PropTypes from 'prop-types';
import queryString from 'query-string';
import { PureComponent } from 'react';
import { withRouter } from 'react-router-dom';
import { RuntimeContext } from '../../../../common/RuntimeContext';

class AdminReauthenticationCallback extends PureComponent {
    static propTypes = {
        history: PropTypes.shape({
            location: PropTypes.shape({
                search: PropTypes.string
            })
        })
    };
    static contextType = RuntimeContext;

    componentDidMount() {
        const {
            history: { location }
        } = this.props;
        const nextPath = queryString.parse(location.search).targetPath || '/authenticate';
        return history.push('/errorpage');
    }

    render() {
        return null;
    }
}

export default withRouter(AdminReauthenticationCallback);
